import { Link, useSidebarOpenState } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';

export type SubLink = { title: string; to: string };

const ICON_CENTER = 36;
const TEXT_INDENT = 56;

const useStyles = makeStyles(theme => ({
  list: {
    marginLeft: ICON_CENTER,
    borderLeft: '1px solid rgba(255,255,255,0.12)',
    overflow: 'hidden',
    maxHeight: 0,
    opacity: 0,
    transition: theme.transitions.create(['max-height', 'opacity'], {
      duration: theme.transitions.duration.shorter,
    }),
  },
  listOpen: {
    maxHeight: 200,
    opacity: 1,
    marginBottom: theme.spacing(0.5),
  },
  link: {
    display: 'block',
    padding: `5px 8px 5px ${TEXT_INDENT - ICON_CENTER - 1}px`,
    fontSize: 12.5,
    lineHeight: '18px',
    color: 'rgba(181,181,181,0.8)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&:hover': { color: '#FFFFFF', textDecoration: 'none' },
    '&:focus-visible': { outline: '2px solid #1DB8F2', outlineOffset: -2 },
  },
}));

// Quiet, indented links under a primary sidebar item. Only visible while the
// sidebar is expanded; collapsed it stays icon-only like every other item.
export const SidebarSubLinks = ({ links }: { links: SubLink[] }) => {
  const classes = useStyles();
  const { isOpen } = useSidebarOpenState();
  return (
    <div
      className={`${classes.list} ${isOpen ? classes.listOpen : ''}`}
      aria-hidden={!isOpen}
    >
      {links.map(l => (
        <Link
          key={l.title}
          to={l.to}
          underline="none"
          className={classes.link}
          tabIndex={isOpen ? 0 : -1}
        >
          {l.title}
        </Link>
      ))}
    </div>
  );
};
